// Utility helpers for activity/attraction matching
// The list may contain strings (names), attraction objects ({ id, name, ... })
// or ticket objects ({ name, type, ... }).
const normalizeLabel = (o) => (o?.label || o?.name || o?.title || o?.id || '').toString().trim().toLowerCase();

function ticketsEqual(a, b) {
    if (!a || !b) return false;
    const aName = typeof a === 'string' ? a : a.name ?? a.id ?? a;
    const bName = typeof b === 'string' ? b : b.name ?? b.id ?? b;
    const aType = typeof a === 'string' ? undefined : a.type;
    const bType = typeof b === 'string' ? undefined : b.type;
    if (aName && bName && String(aName) === String(bName)) {
        // If both have explicit types, require them to match.
        // If one or both don't have a type, consider the name match sufficient.
        if (aType !== undefined && bType !== undefined) {
            return String(aType) === String(bType);
        }
        return true;
    }
    return false;
}

function attractionsEqual(aList = [], bList = []) {
    if (!Array.isArray(aList) || !Array.isArray(bList)) return false;
    if (aList.length !== bList.length) return false;
    const aKeys = aList.map(a => normalizeLabel(a)).sort();
    const bKeys = bList.map(b => normalizeLabel(b)).sort();
    return aKeys.every((k, i) => k === bKeys[i]);
}

function isTicketAdded(list, ticketKey) {
    if (!Array.isArray(list)) return false;
    return list.some((entry) => {
        if (!entry) return false;
        if (typeof entry === 'string') {
            return String(entry) === String(ticketKey.name);
        }
        if (typeof entry === 'object') {
            if (entry.name && entry.type) return String(entry.name) === String(ticketKey.name) && String(entry.type) === String(ticketKey.type);
            const id = entry.id ?? entry.ID ?? null;
            if (id && (String(id) === String(ticketKey.name) || String(id) === String(ticketKey.type))) return true;
            if (entry.name && String(entry.name) === String(ticketKey.name)) return true;
        }
        return false;
    });
}

module.exports = {
    isTicketAdded,
    normalizeLabel,
    ticketsEqual,
    attractionsEqual,
};
